export default {
  meta: {
    title: '门店保护申请',
    url: '/standardstore/index', // 埋点字段，上报归属的模块
    urlName: '拓店标准版' // 埋点字段，上报归属的模块
  }
};
